import { useMemo } from 'react';

import useLead from '~/features/leadDetails/hooks/useLead';
import { useChats } from '~/features/whatsapp/hooks/useChats';
import { useOwnDivisionPhoneNumberId } from '~/features/whatsapp/hooks/useOwnDivisionPhoneNumberId';
import { resolveApplicantChats } from '~/features/whatsapp/utils/resolveApplicantChats';

export const useApplicantChats = (loanRequestId: string | undefined) => {
    const { data: lead } = useLead(loanRequestId);
    const { data: chats } = useChats();
    const ownPhoneNumberId = useOwnDivisionPhoneNumberId();

    return useMemo(() => {
        if (!loanRequestId || !lead) return null;
        const leadChats = chats?.filter((chat) => chat.loanRequestIds.includes(loanRequestId)) ?? [];
        return resolveApplicantChats(lead, leadChats, ownPhoneNumberId);
    }, [chats, lead, loanRequestId, ownPhoneNumberId]);
};
